// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
  --maxDialogWidth:34rem;
  --maxDialogContentHeight:16rem;
  --dialogZIndex:10;
}

ftr-dialog{
  position:fixed;
  top:0;
  left:0;
  z-index:10;
  width:100%;
  height:100%;
  pointer-events:none;
}

.dialog__container{
  display:flex;
  align-items:center;
  justify-content:center;
  width:100%;
  height:100%;
}

.dialog__backdrop{
  position:absolute;
  top:0;
  left:0;
  z-index:10;
  width:100%;
  height:100%;
  pointer-events:auto;
  background:rgb(0, 0, 0, 0.3);
}

.dialog{
  z-index:11;
  display:flex;
  flex-direction:column;
  gap:1rem;
  max-width:34rem;
  padding:1rem;
  pointer-events:auto;
  background:#fff;
  border-radius:0.25rem;
  box-shadow:0 2px 2px rgb(0, 0, 0, 0.3);
}

@media (width <= 640px){

.dialog{
    margin:1rem
}
  }

.dialog__header{
    display:flex;
    align-items:center;
    justify-content:space-between;
  }

.dialog__header h2{
      margin:0;
    }

.dialog__close{
    display:flex;
    flex-grow:1;
    justify-content:flex-end;
  }

.dialog__close .button--icon{
      width:unset;
    }

.dialog__content{
    max-height:16rem;
    overflow-y:auto;
  }

.dialog__footer{
    display:flex;
    gap:1rem;
    justify-content:flex-end;
  }

@media (width <= 640px){

.dialog__footer{
      flex-direction:column
  }
    }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
